/* eslint-disable no-unused-vars */
import React, { FC, memo, useCallback, useEffect, useState } from 'react';
import { Checkbox, FormControl, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { unwrapResult } from '@reduxjs/toolkit';
import { slices, useAppDispatch } from 'src/redux';
import { ManufacturerOption } from 'src/types';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { Chip } from '@material-ui/core';

const { actions: manufacturerActions } = slices.manufacturer;

interface Props {
  label?: string;
  isMultiple?: boolean;
  initialValue?: number[];
  onHandleManufacturerSetValue: (manufacturer_ids: number[]) => void;
}

const Component: FC<Props> = ({
  label = 'manufacturers',
  initialValue = [], // Default to empty array
  onHandleManufacturerSetValue
}) => {
  const dispatch = useAppDispatch();

  const [manufacturerOption, setManufacturerOption] = useState<
    ManufacturerOption[]
  >([]);
  const [manufacturerVal, setManufacturerVal] = useState<ManufacturerOption[]>(
    []
  );

  const getManufacturers = async () => {
    const getManufacturersResponse = unwrapResult(
      await dispatch(manufacturerActions.getManufacturersThunk({ limit: 9999 }))
    );
    if (getManufacturersResponse?.success) {
      const manufacturers = getManufacturersResponse?.originalData?.data;
      const manufacturerOptions = manufacturers?.map((i) => ({
        label: i.name || '',
        id: i.id ?? 0
      }));

      setManufacturerOption(manufacturerOptions || []);

      // Apply initialValue (ensure it's an array)
      const initialArray = Array.isArray(initialValue)
        ? initialValue
        : [initialValue];
      if (initialArray.length > 0) {
        const selected = manufacturerOptions?.filter((opt) =>
          initialArray.includes(opt.id)
        );
        setManufacturerVal(selected || []);
        onHandleManufacturerSetValue(selected?.map((s) => s.id) || []);
      }
    } else {
      console.error('Failed to get Manufacturers');
    }
  };

  const onManufacturerChange = useCallback(
    (event: any, value: ManufacturerOption[] | null) => {
      const values = value ?? [];
      setManufacturerVal(values);

      const ids = values.map((v) => v.id);
      onHandleManufacturerSetValue(ids);
    },
    [onHandleManufacturerSetValue]
  );

  useEffect(() => {
    getManufacturers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <FormControl variant="outlined" fullWidth>
        <Autocomplete
          multiple
          limitTags={2}
          id="checkboxes-tags-demo"
          value={manufacturerVal} // Use `value` instead of `defaultValue`
          options={manufacturerOption}
          disableCloseOnSelect
          getOptionLabel={(option) => option?.label}
          onChange={(event, value: any) => onManufacturerChange(event, value)}
          renderOption={(option, { selected }) => (
            <React.Fragment>
              <Checkbox
                icon={<CheckBoxOutlineBlankIcon />}
                checkedIcon={<CheckBoxIcon />}
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {option?.label}
            </React.Fragment>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label={label}
              placeholder="Excluded Manufacturers"
            />
          )}
        />
      </FormControl>
    </div>
  );
};

export const ManufacturerDropDownV2 = memo(Component);
